import { useParams } from 'react-router-dom'
import { useState } from 'react'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Row,
  Space,
  theme,
  Typography,
} from 'antd'
import { errorResponse } from '../../lib/errorResponse'
import { gutter } from '../../lib/layout'
import { doc, setDoc } from 'firebase/firestore'
import { useFirestore } from 'reactfire'
import summerSchedule from '../../resources/img/summer-schedule.svg'
import { Trans, useTranslation } from 'react-i18next'

export function StepDeregistrationReason({
  onboarding,
  goToNext,
  goToPrevious,
}) {
  const { companyUid } = useParams()
  const [loading, setLoading] = useState(false)

  const { token } = theme.useToken()
  const firestore = useFirestore()
  const { t } = useTranslation()

  async function onSubmit() {
    setLoading(true)
    try {
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  async function onValuesChange(values) {
    setLoading(true)
    try {
      const finalValues = {
        acceptedDeregistration: values.acceptedDeregistration,
      }
      await setDoc(doc(firestore, 'onboarding', companyUid), finalValues, {
        merge: true,
      })
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  const [form] = Form.useForm()

  const initialValues = {
    acceptedDeregistration: onboarding.acceptedDeregistration,
  }

  return (
    <>
      <img
        style={{
          position: 'absolute',
          top: 0,
          left: -220,
          width: 550,
          zIndex: 1,
        }}
        src={summerSchedule}
        alt=""
      />
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '35em',
          marginLeft: 'auto',
        }}
      >
        <Form
          style={{ marginTop: token.marginXXL }}
          form={form}
          onFinish={onSubmit}
          colon={false}
          layout="vertical"
          initialValues={initialValues}
          onValuesChange={onValuesChange}
        >
          {onboarding.software === 'agenda' ? (
            <>
              <Row gutter={gutter}>
                <Col span={24}>
                  <Typography.Title level={4}>
                    {t('frontend:onboarding.noDeregistrationTitle')}
                  </Typography.Title>

                  <Typography.Paragraph>
                    <Trans
                      i18nKey="frontend:onboarding.noDeregistrationText"
                      components={{ strong: <Typography.Text strong /> }}
                    />
                  </Typography.Paragraph>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={['acceptedDeregistration']}
                    rules={[
                      {
                        validator: async (_, checked) => {
                          if (!checked) {
                            return Promise.reject(
                              new Error(t('frontend:onboarding.pleaseConfirm'))
                            )
                          }
                        },
                      },
                    ]}
                    valuePropName={'checked'}
                  >
                    <Checkbox>
                      <Trans
                        i18nKey="frontend:onboarding.noDeregistrationConfirm"
                        components={{ strong: <Typography.Text strong /> }}
                      />
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row gutter={gutter}>
                <Col span={24}>
                  <Typography.Title level={4}>
                    {t('frontend:onboarding.deregistrationTitle')}
                  </Typography.Title>

                  <Typography.Paragraph>
                    <Trans
                      i18nKey="frontend:onboarding.deregistrationText"
                      components={{ strong: <Typography.Text strong /> }}
                    />
                  </Typography.Paragraph>
                  <Typography.Paragraph>
                    {t('frontend:onboarding.deregistrationPlease')}
                  </Typography.Paragraph>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={['acceptedDeregistration']}
                    rules={[
                      {
                        validator: async (_, checked) => {
                          if (!checked) {
                            return Promise.reject(
                              new Error(t('frontend:onboarding.pleaseConfirm'))
                            )
                          }
                        },
                      },
                    ]}
                    valuePropName={'checked'}
                  >
                    <Checkbox>
                      <Trans
                        i18nKey="frontend:onboarding.deregistrationConfirm"
                        components={{ strong: <Typography.Text strong /> }}
                      />
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <div style={{ textAlign: 'right', marginTop: token.marginLG }}>
            <Space>
              <Button type="text" onClick={() => goToPrevious()}>
                {t('frontend:common.back')}
              </Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                {t('frontend:onboarding.next')}
              </Button>
            </Space>
          </div>
        </Form>
      </div>
    </>
  )
}
